import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, DialogActions, DialogContent, DialogTitle, makeStyles } from '@material-ui/core'
import SydButton from '../../../../commonDesign/Button'

const useStyles = makeStyles(() => ({
  paper: {
    minWidth: '420px',
    maxWidth: '520px'
  },
  title: {
    fontSize: 'var(--text-size-lg, 18px)',
    fontWeight: 600,
    color: 'var(--color-neutral-900)'
  },
  body: {
    fontSize: 'var(--text-size-sm)',
    color: 'var(--color-neutral-700)',
    lineHeight: 1.6
  },
  mono: {
    fontFamily: 'var(--font-mono, monospace)',
    fontSize: 'var(--text-size-xs)',
    backgroundColor: 'var(--color-neutral-050)',
    padding: '2px 6px',
    borderRadius: 'var(--border-radius-sm)',
    color: 'var(--color-neutral-700)'
  }
}))

function ConfirmDeleteDialog ({ open, entityLabel, recordId, onCancel, onConfirm, isMutating }) {
  const classes = useStyles()
  return (
    <Dialog open={open} onClose={onCancel} classes={{ paper: classes.paper }}>
      <DialogTitle disableTypography>
        <div className={classes.title}>Delete {entityLabel.toLowerCase()}?</div>
      </DialogTitle>
      <DialogContent>
        <div className={classes.body}>
          You are about to permanently delete{' '}
          {recordId ? <span className={classes.mono}>{recordId}</span> : `this ${entityLabel.toLowerCase()}`}.
          {' '}This cannot be undone.
        </div>
      </DialogContent>
      <DialogActions>
        <SydButton size='sm' variant='secondary' onClick={onCancel} disabled={isMutating}>Cancel</SydButton>
        <SydButton size='sm' variant='primary' priority='warning' onClick={onConfirm} processing={isMutating}>
          Delete
        </SydButton>
      </DialogActions>
    </Dialog>
  )
}

ConfirmDeleteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  entityLabel: PropTypes.string.isRequired,
  recordId: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isMutating: PropTypes.bool
}

ConfirmDeleteDialog.defaultProps = {
  recordId: undefined,
  isMutating: false
}

export default ConfirmDeleteDialog
